import { LcACLConfig } from './lc-acl.type';

export const ACL_DEFAULT_CONFIG: LcACLConfig = {
  guard_url: `/auth/403`,
};
